export enum LauncherFeatureTooltipTypeEnum {
    'Strech_To_Fit' = 'Fit video resolution to full-screen'
}
